import type { TranslationMessages } from './types';

export const common: TranslationMessages = {
  all: 'All',
  actions: 'Actions',
  search: 'Search',
  add: 'Add',
  close: 'Close',
  cancel: 'Cancel',
  accessDenied: 'Access Denied',
  page: 'Page',
  of: 'of',
  total: 'total',
  groups: 'groups',
  total_items: 'total items',
  noPermissionCostManagement:
    'You do not have permission to view cost management.',
  noPermissionCostCategoryManagement:
    'You do not have permission to view cost category management.',
  actionsObj: {
    cancel: 'Close',
    save: 'Save',
    edit: 'Edit',
    delete: 'Delete',
    create: 'Create',
    update: 'Update',
    filter: 'Filter',
    clear: 'Clear',
    all: 'All',
    loading: 'Loading...',
  },
  filters: 'Filters',
  filter: 'Filter',
  create: 'Create',
  update: 'Update',
  delete: 'Delete',
  save: 'Save',
  saving: 'Saving...',
  loadingCosts: 'Loading costs...',
  loadingCostCategories: 'Loading cost categories...',
  date_range: 'Date Range',
  none: 'None',
};
